import React from 'react';
import PropTypes from 'prop-types';
import './tag.scss';

const Tag = ({ children, onClick, route }) => (
  <a
    href={route}
    target="_parent"
    type="button"
    onClick={onClick}
    className="tag"
    title={`Ver resultados en ${children}`}
    rel="noreferrer"
  >
    {children}
  </a>
);

Tag.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  onClick: PropTypes.func.isRequired
};

export default Tag;
